/* eslint-disable no-useless-escape */
export const emailValidation = (value: string): string | true => {
  if (!value) {
    return "Email é necessário";
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return "Por favor, insira um email válido";
  }
  return true;
};

export const passwordValidation = (value: string): string | true => {
  if (!value) {
    return "Senha é necessária";
  }
  if (value.length < 8) {
    return "Senha deve ter pelo menos 8 caracteres";
  }
  if (value.length > 20) {
    return "Senha deve ter no máximo 20 caracteres";
  }
  return true;
};

export const confirmPasswordValidation =
  (password: string) =>
  (value: string): string | true => {
    if (!value) {
      return "Confirmação de senha é necessária";
    }
    if (value !== password) {
      return "As senhas não coincidem";
    }
    return true;
  };

export const usernameValidation = (value: string): string | true => {
  if (!value) {
    return "Username é necessário";
  }
  if (value.length < 3) {
    return "Username deve ter pelo menos 3 caracteres";
  }
  if (value.length > 20) {
    return "Username deve ter no máximo 20 caracteres";
  }
  return true;
};

export const nameValidation = (value: string): string | true => {
  if (!value) {
    return "O nome completo é obrigatório.";
  }
  if (value.length < 3) {
    return "O nome completo deve ter pelo menos 3 caracteres.";
  }
  return true;
};

export const validateLinkLattes = (value: string): true | string => {
  if (!value) {
    return true;
  }
  const urlRegex =
    /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([/\w \.-]*)*\/?$/;
  const lattesRegex = /^https?:\/\/(?:www\.)?lattes\.cnpq\.br\/\d{16}$/;
  if (!urlRegex.test(value)) {
    return "A URL fornecida não é válida.";
  }
  if (!lattesRegex.test(value)) {
    return "A URL fornecida não pertence ao formato específico do Lattes.";
  }
  return true;
};

export const fieldRequiredValidation = (value: string): string | true => {
  if (!value) {
    return "Esse campo é obrigatório";
  }
  return true;
};

export const validateSelectionRequired = (value: string): string | true => {
  if (!value) {
    console.log(value);
    return "Selecione uma linguagem";
  }
  return true;
};

export const validateURL = (str: string): string | true => {
  // Verifica se a string começa com "http://" ou "https://"
  const protocolRegex = /^(https?):\/\//i;

  if (!str) {
    return "Esse campo é obrigatório";
  }

  if (!protocolRegex.test(str)) {
    return "O link precisa começar com 'https://'.";
  }

  // Verifica se é uma URL válida
  const urlRegex = /^(https?):\/\/[^\s/$.?#].[^\s]*$/i;
  if (!urlRegex.test(str)) {
    return "O link fornecido não é válido.";
  }

  return true;
};
export function validarDataNascimento(data: string): boolean {
  // Verificar se o formato da data é DD/MM/AAAA
  const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  if (!regex.test(data)) {
    return false;
  }

  // Converter a data para o formato Date e verificar se é válida
  const [dia, mes, ano] = data.split("/").map((item) => parseInt(item));
  const dataValida = new Date(ano, mes - 1, dia); // mês começa do 0, por isso -1
  const hoje = new Date();

  // Verificar se a data não é futura
  if (dataValida > hoje) {
    return false;
  }

  // Verificar se o dia, mês e ano correspondem à data válida
  if (
    dataValida.getDate() !== dia ||
    dataValida.getMonth() !== mes - 1 ||
    dataValida.getFullYear() !== ano
  ) {
    return false;
  }

  return true;
}
